// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert_logo {
  cursor: pointer;
}

.overlay-tooltip-grey-out .tooltip-arrow::before {
  top: -1px;
  border-top-color: white !important;
}
.overlay-tooltip-grey-out .tooltip-inner {
  display: inline;
  padding: 0.2em 0;
  padding: 4px 16px;
  margin-left: 8.1rem;
  margin-top: -0.188rem;
  width: 100%;
  display: flex;
  color: black;
  font-size: 0.9rem;
  text-align: left;
  align-items: center;
  font-weight: 600;
  white-space: pre-line;
  word-break: break-word;
  justify-content: center;
  background-color: white !important;
  border: 1px solid #fff7f7;
}
.overlay-tooltip-grey-out .tooltip-inner ::after {
  left: 50%;
  top: 100%;
  content: "";
  position: absolute;
  border-style: solid;
  margin-left: -0.625rem;
  border-width: 0.625rem;
  border-color: black transparent transparent transparent;
}

.overlay-tooltip .tooltip-arrow::before {
  top: -1px;
  border-top-color: white !important;
}
.overlay-tooltip .tooltip-inner {
  display: inline;
  max-width: 8rem;
  min-width: 7rem;
  padding: 0.2em 0;
  margin-left: 4.1rem;
  padding: 0.25rem 1rem;
  margin-top: -0.188rem;
  width: 100%;
  display: flex;
  color: black;
  font-size: 0.8rem;
  text-align: left;
  align-items: center;
  white-space: pre-line;
  word-break: break-word;
  justify-content: center;
  background-color: white !important;
  border: 1px solid #fff7f7;
}
.overlay-tooltip .tooltip-inner ::after {
  left: 50%;
  top: 100%;
  content: "";
  position: absolute;
  border-style: solid;
  margin-left: -0.625rem;
  border-width: 0.625rem;
  border-color: black transparent transparent transparent;
}

.p-tooltip.p-tooltip-top.tooltip-white {
  padding: 0.2em 0;
  margin-left: 3.1rem;
  margin-top: -0.188rem;
}
.p-tooltip.p-tooltip-top.tooltip-white .p-tooltip-text {
  width: 100%;
  display: flex;
  color: black;
  font-size: 0.8rem;
  text-align: left;
  align-items: center;
  white-space: pre-line;
  word-break: break-word;
  justify-content: center;
  background-color: white;
  border: 1px solid #fff7f7;
}
.p-tooltip.p-tooltip-top.tooltip-white .p-tooltip-text ::after {
  left: 50%;
  top: 100%;
  content: "";
  position: absolute;
  border-style: solid;
  margin-left: -0.625rem;
  border-width: 0.625rem;
  border-color: black transparent transparent transparent;
}
.p-tooltip.p-tooltip-top.tooltip-white .p-tooltip-arrow {
  content: "";
  top: 89%;
  left: 10%;
  position: absolute;
  border-width: 1rem;
  border-style: solid;
  margin-left: -0.313rem;
  border-color: white transparent transparent transparent;
}

.p-tooltip.p-tooltip-top.grey-out-tooltip {
  padding: 0.2em 0;
  margin-top: -1.25rem;
  margin-left: 12.59rem;
}
.p-tooltip.p-tooltip-top.grey-out-tooltip .p-tooltip-text {
  display: flex;
  color: black;
  width: 16.375rem;
  font-size: 0.75rem;
  text-align: left;
  align-items: center;
  white-space: pre-line;
  word-break: break-word;
  justify-content: center;
  background-color: white;
  border: 1px solid #fff7f7;
}
.p-tooltip.p-tooltip-top.grey-out-tooltip .p-tooltip-arrow {
  content: "";
  top: 89%;
  left: 10%;
  position: absolute;
  border-width: 1rem;
  border-style: solid;
  margin-left: -0.313rem;
  border-color: white transparent transparent transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/common/AlertIcon/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAGE;EACE,SAAA;EACA,kCAAA;AAAJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EAEA,WAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kCAAA;EACA,yBAAA;AADJ;AAEI;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uDAAA;AAAN;;AAKE;EACE,SAAA;EACA,kCAAA;AAFJ;AAIE;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,WAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kCAAA;EACA,yBAAA;AAHJ;AAII;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uDAAA;AAFN;;AAkEA;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;AA/DF;AAiEE;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;AA/DJ;AAgEI;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uDAAA;AA9DN;AAkEE;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uDAAA;AAhEJ;;AAoEA;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;AAjEF;AAkEE;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;AAhEJ;AAmEE;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uDAAA;AAjEJ","sourcesContent":[".alert_logo {\n  cursor: pointer;\n}\n\n.overlay-tooltip-grey-out {\n  .tooltip-arrow::before {\n    top: -1px;\n    border-top-color: white !important;\n  }\n  .tooltip-inner {\n    display: inline;\n    padding: 0.2em 0;\n    padding: 4px 16px;\n    margin-left: 8.1rem;\n    margin-top: -0.188rem;\n\n    width: 100%;\n    display: flex;\n    color: black;\n    font-size: 0.9rem;\n    text-align: left;\n    align-items: center;\n    font-weight: 600;\n    white-space: pre-line;\n    word-break: break-word;\n    justify-content: center;\n    background-color: white !important;\n    border: 1px solid #fff7f7;\n    ::after {\n      left: 50%;\n      top: 100%;\n      content: '';\n      position: absolute;\n      border-style: solid;\n      margin-left: -0.625rem;\n      border-width: 0.625rem;\n      border-color: black transparent transparent transparent;\n    }\n  }\n}\n.overlay-tooltip {\n  .tooltip-arrow::before {\n    top: -1px;\n    border-top-color: white !important;\n  }\n  .tooltip-inner {\n    display: inline;\n    max-width: 8rem;\n    min-width: 7rem;\n    padding: 0.2em 0;\n    margin-left: 4.1rem;\n    padding: .25rem 1rem;\n    margin-top: -0.188rem;\n\n    width: 100%;\n    display: flex;\n    color: black;\n    font-size: 0.8rem;\n    text-align: left;\n    align-items: center;\n    white-space: pre-line;\n    word-break: break-word;\n    justify-content: center;\n    background-color: white !important;\n    border: 1px solid #fff7f7;\n    ::after {\n      left: 50%;\n      top: 100%;\n      content: '';\n      position: absolute;\n      border-style: solid;\n      margin-left: -0.625rem;\n      border-width: 0.625rem;\n      border-color: black transparent transparent transparent;\n    }\n  }\n}\n\n// .p-tooltip.p-tooltip-top.tooltip-white {\n//   padding: 0.2em 0;\n//   margin-left: 3.1rem;\n//   margin-top: -0.188rem;\n//   &.grey-out-tooltip {\n//     padding: 0.2em 0;\n//     margin-top: -1.25rem;\n//     margin-left: 12.59rem;\n//     .p-tooltip-text {\n//       display: flex;\n//       color: black;\n//       width: 16.375rem;\n//       font-size: 0.75rem;\n//       text-align: left;\n//       align-items: center;\n//       white-space: pre-line;\n//       word-break: break-word;\n//       justify-content: center;\n//       background-color: white;\n//       border: 1px solid #fff7f7;\n//     }\n//   }\n\n//   .p-tooltip-text {\n//     width: 100%;\n//     display: flex;\n//     color: black;\n//     font-size: 0.8rem;\n//     text-align: left;\n//     align-items: center;\n//     white-space: pre-line;\n//     word-break: break-word;\n//     justify-content: center;\n//     background-color: white;\n//     border: 1px solid #fff7f7;\n//     ::after {\n//       left: 50%;\n//       top: 100%;\n//       content: \"\";\n//       position: absolute;\n//       border-style: solid;\n//       margin-left: -0.625rem;\n//       border-width: 0.625rem;\n//       border-color: black transparent transparent transparent;\n//     }\n//   }\n\n//   .p-tooltip-arrow {\n//     content: \"\";\n//     top: 89%;\n//     left: 10%;\n//     position: absolute;\n//     border-width: 1rem;\n//     border-style: solid;\n//     margin-left: -0.313rem;\n//     border-color: white transparent transparent transparent;\n//   }\n// }\n\n.p-tooltip.p-tooltip-top.tooltip-white {\n  padding: 0.2em 0;\n  margin-left: 3.1rem;\n  margin-top: -0.188rem;\n\n  .p-tooltip-text {\n    width: 100%;\n    display: flex;\n    color: black;\n    font-size: 0.8rem;\n    text-align: left;\n    align-items: center;\n    white-space: pre-line;\n    word-break: break-word;\n    justify-content: center;\n    background-color: white;\n    border: 1px solid #fff7f7;\n    ::after {\n      left: 50%;\n      top: 100%;\n      content: '';\n      position: absolute;\n      border-style: solid;\n      margin-left: -0.625rem;\n      border-width: 0.625rem;\n      border-color: black transparent transparent transparent;\n    }\n  }\n\n  .p-tooltip-arrow {\n    content: '';\n    top: 89%;\n    left: 10%;\n    position: absolute;\n    border-width: 1rem;\n    border-style: solid;\n    margin-left: -0.313rem;\n    border-color: white transparent transparent transparent;\n  }\n}\n\n.p-tooltip.p-tooltip-top.grey-out-tooltip {\n  padding: 0.2em 0;\n  margin-top: -1.25rem;\n  margin-left: 12.59rem;\n  .p-tooltip-text {\n    display: flex;\n    color: black;\n    width: 16.375rem;\n    font-size: 0.75rem;\n    text-align: left;\n    align-items: center;\n    white-space: pre-line;\n    word-break: break-word;\n    justify-content: center;\n    background-color: white;\n    border: 1px solid #fff7f7;\n  }\n\n  .p-tooltip-arrow {\n    content: '';\n    top: 89%;\n    left: 10%;\n    position: absolute;\n    border-width: 1rem;\n    border-style: solid;\n    margin-left: -0.313rem;\n    border-color: white transparent transparent transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
